<template>
    <TemplatesPage :info-message="getNotFoundMessage">
        <div class="field">
            <label>{{ $t('lang.tools.similarkeywords.field_label') }}</label>
            <InputText v-model="model.keyword" />
        </div>
        <div class="mb-4">
            <Button :label="$t('lang.tools.similarkeywords.button_label')" @click.prevent="onClickButton" />
        </div>
    </TemplatesPage>
</template>

<script>
import TemplatesPage from "../../templates/Page.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

export default {
    name: "SitePagesStart",
    props: {
        base: {
            type: String,
            required: true,
        },
        keyword: {
            type: String,
            required: false,
            default: null,
        },
        notFound: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            model: {
                keyword: null,
            }
        };
    },
    created() {
        this.model.keyword = this.keyword;
    },
    computed: {
        getNotFoundMessage() {
            return this.notFound ? this.$t('lang.tools.similarkeywords.not_found') : null;
        },
    },
    methods: {
        onClickButton() {
            window.open(sprintf('/%s/similarkeys?key=%s&db=%s', window.locale, this.model.keyword, this.base), '_self');
        },
    },
    components: {
        TemplatesPage,
        InputText,
        Button,
    },
}
</script>
